<template>
  <el-dialog
    class="form-modal"
    :visible.sync="bulkRebootVisible"
    width="400px"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <h2 class="form-section-header" style="margin-top: 0px">
      Bulk Device Reboot
    </h2>

    <el-form>
      <dads-select v-model="phPmId" placeholder="Select phone model" filterable>
        <template slot="prefix">Phone model</template>
        <el-option
          v-for="(item, index) in deviceModelOptions"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </dads-select>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelOperation">Cancel</el-button>
      <el-button
        type="primary"
        :disabled="phPmId === null"
        @click="bulkRebootOperation"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import DadsSelect from "@/components/select";

export default {
  name: "BulkRebootModal",

  props: {
    bulkRebootVisible: { required: true },
    bulkRebootProcessing: { required: true },
    deviceModelOptions: { required: true },
    clearFormFields: {
      type: Boolean,
      required: true,
    },
  },

  components: { DadsSelect },

  data() {
    return {
      phPmId: null,
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },
  },

  methods: {
    cancelOperation() {
      this.$emit("cancelOperation", "bulkReboot");
    },

    bulkRebootOperation() {
      this.$emit("bulkRebootOperation", this.phPmId);
    },

    clearFields() {
      this.phPmId = null;
    },
  },
};
</script>
